import styled from "styled-components";

import { ContainerInterface, RadioButtonInterface } from "./interfaces";

export const Main = styled.div`
    padding-left: 0px;
    padding-right: 10px;
    display: block;

    @media (max-width: 600px){
        padding-right: 0px;
        display: ${(p: ContainerInterface) => p.isSideContainerVisible ? "none" : "block"};
    }
`;

export const Container = styled.div`
    width: 100%;
    display: ${(p: ContainerInterface) => p.isSideContainerVisible ? "block" : "flex"};
    flex-wrap: wrap;

    @media (max-width: 600px){
        display: ${(p: ContainerInterface) => p.isSideContainerVisible ? "none" : "block"};
    }
`;

export const BankAccount = styled.div`
    width: 429px;
    padding-left: 0px;
    padding-right: 30px;
    @media (max-width: 600px){
        width: 100%;
        padding: 0px;
    }
`

export const BankAccountContainer = styled.div`
    width: 100%;
    margin-bottom: 45px;
    border-radius: 10px;
    padding: 23px 31px;
    margin-right: 30px;
    background-color: #F2F1FA;

    @media (max-width: 600px){
        margin-right: 0px;
    }
`;

export const BankAccountContainerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 34px;
`;

export const BankAccountContainerHeaderTitle = styled.h3`
    font: normal normal normal 15px/21px Circular Std Book;
    color: ${(p: RadioButtonInterface) => p.isPrimary ? "#F58B1E" : "#B8B4CC"};
    margin-bottom: 0px;
    margin-right: 19px;
`;

export const BankAccountContainerBody = styled.div`
    display: flex;
    padding-left: 6px;
`;

export const EditButton = styled.button`
    display: flex;
    border: none;
    outline: none;
    background-color: transparent;
    font: normal normal normal 10px/14px Circular Std Book;
    color: #B8B4CC;

    &:focus {
        outline: none;
    }
`;

export const RadioButtonContainer = styled.div`
    display: flex;
    width: 18px;
    height: 18px;
    justify-content: center;
    align-items: center;
    border: 1px solid #F58B1E;
    border-radius: 9px;
`;

export const RadioButtonContent = styled.div`
    width: 10px;
    height: 10px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? "#F58B1E" : "transparent"};
`;

export const DataContainer = styled.div`
    margin-bottom: 15px;
`

export const Title = styled.span`
    font: normal normal 600 10px/13px Muli;
    color: #B8B4CC;
`

export const Info = styled.p`
    margin-bottom: 0px;
    font: normal normal bold 10px/13px Muli;
    color: #454546;
`

export const Legend = styled.legend`
    margin-top: 41px;
    margin-bottom: 17px;
    color: #454546;
    font-size: 13px;
`;

export const Select = styled.select`
    width:100%;
    height: 31px;
    margin-bottom: 23px;
    background: #fff;
    color: #454546;
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid #eea94993;
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: #F6F5FA;
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const FormRadioButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    height: 13px;
    font: normal normal 300 10px/13px Muli;
    color: #707070;
    margin-right: 25px;
`;

export const FormRadioButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10px;
    height: 10px;
    border: 1px solid #F58B1E;
    border-radius: 5px;
    margin-right: 10px;
`

export const FormRadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? "#F58B1E" : "transparent"};
    border-radius: 5px;
`

export const InputWithHintContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 23px;
`